export const getDiscount = (data) => {
    if (!data) {
        return null;
    }
    const { price_range: { minimum_price: { discount: { percent_off: percentOff }, }, }, } = data;
    if (!percentOff) {
        return null;
    }
    return percentOff;
};
export const getDiscountBySKU = (currentVariantSku, { variants }) => {
    const product = variants.find((item) => item.product.sku === currentVariantSku);
    if (!product) {
        return null;
    }
    const { percent_off: percentOff } = product.product.price_range.minimum_price.discount;
    return !percentOff ? null : percentOff;
};
//# sourceMappingURL=getDiscount.js.map